import { Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";
export var IconWrapper = function IconWrapper(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement(Wrapper, {
    onClick: onClick,
    "$disabled": disabled
  }, children);
};
var Wrapper = styled(Row).attrs({
  align: "center",
  justify: "flex-start"
}).withConfig({
  displayName: "IconWrapper__Wrapper"
})(["padding-left:", ";margin-bottom:", ";"], getSpacing("1/2x"), getSpacing("1/2x"));